import {TaxGroupService} from "../../../services/catalogs/TaxGroupService";
import {CreateTaxGroupDto} from "../../../dtos/catalogs/taxGroup/CreateTaxGroupDto";
import React from "react";
import {TaxGroupDetail} from "../../../components/Pages/Catalogs/Tax Group/TaxGroupDetail";

import {CatalogService} from "../../../services/catalogs/CatalogService";
import {IAppEntity} from "../../entities";
import {ReferenceTypes} from "../../../enums/ReferenceTypes";
import {NFLookupTaxGroup} from "../../../components/Shared/NewForms/NFLookupTaxGroup";
import TaxGroupList from "../../../components/Pages/Catalogs/Tax Group/TaxGroupList";

export const TaxGroup: IAppEntity = {
    entityType: "catalog",
    title: "Tax Group",
    pluralTitle: "Tax Group",
    apiUrl: "TaxGroups",
    apiEnum: ReferenceTypes.CatalogTaxGroup,
    getDetailViewComponent(
        model: any,
        modelUpdatedEvent: (model: any) => void
    ): any {
        return React.createElement(TaxGroupDetail, {
            model: model,
            modelUpdatedEvent: modelUpdatedEvent,
        });
    },
    getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
        React.createElement(TaxGroupList, {
            model: model,
            modelUpdatedEvent: modelUpdatedEvent,
        }),
    getLookupComponent(model: any): any {
        return React.createElement(NFLookupTaxGroup, {
            fieldName: model.fieldName,
            title: model.title,
            setSelectedCatalog: model.setSelectedCatalog,
        });
    },
    getDataService() {
        return new TaxGroupService(this.apiUrl);
    },
    getEmptyModel(): CreateTaxGroupDto {
        return {
            name: "",
        };
    },
};
